import React from "react";
import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";

const SIZE_FIELDS = [
    { key: 'width',       labelKey: 'lug_width_label',    labelDefault: 'Lug Width',    unit: 'mm', min: 14, max: 26  },
    { key: 'buckleWidth', labelKey: 'buckle_width_label', labelDefault: 'Buckle Width', unit: 'mm', min: 10, max: 26  },
    { key: 'shortLength', labelKey: 'short_length_label', labelDefault: 'Short Length', unit: 'mm', min: 60, max: 100 },
    { key: 'longLength',  labelKey: 'long_length_label',  labelDefault: 'Long Length',  unit: 'mm', min: 100, max: 150 },
];

const MeasurementPanel = ({
    config,
    measInputs,
    measErrors,
    isOrderFinished,
    onInputChange,
    onBlur,
    onSliderChange,
    onBack,
    onConfirm,
}) => {
    const { t } = useTranslation();
    const hasAnyError = SIZE_FIELDS.some(f => measErrors[f.key]);

    return (
        <>
            <div className="cfg-sec-header">
                <span className="cfg-sec-title">Measurements</span>
            </div>
            <div style={{ overflowY: 'auto', flexGrow: 1 }}>
                {SIZE_FIELDS.map(f => {
                    const inputVal = measInputs[f.key] ?? String(config[f.key] ?? f.min);
                    const configVal = config[f.key] ?? f.min;
                    const sliderVal = isNaN(parseInt(inputVal, 10)) ? configVal : Math.min(f.max, Math.max(f.min, parseInt(inputVal, 10)));
                    const pct = ((sliderVal - f.min) / (f.max - f.min)) * 100;
                    const trackBg = `linear-gradient(to right, #C5A075 ${pct}%, #E4DDD5 ${pct}%)`;
                    const hasErr = !!measErrors[f.key];
                    return (
                        <div key={f.key} className="meas-block">
                            <div className="meas-row-top">
                                <span className="meas-field-label">
                                    {t(f.labelKey, f.labelDefault)}
                                </span>
                                <div className="meas-input-wrap">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className={`meas-num-input${hasErr ? ' has-error' : ''}`}
                                        value={inputVal}
                                        disabled={isOrderFinished}
                                        onChange={e => onInputChange(f.key, e.target.value)}
                                        onBlur={() => onBlur(f)}
                                    />
                                    <span className="meas-unit">mm</span>
                                </div>
                            </div>
                            {hasErr && (
                                <div className="meas-error">
                                    <AlertCircle size={11} />
                                    {measErrors[f.key]}
                                </div>
                            )}
                            <div className="meas-track-wrap" style={{ marginTop: hasErr ? '10px' : '0' }}>
                                <input
                                    type="range"
                                    className="meas-range"
                                    style={{ background: trackBg }}
                                    min={f.min} max={f.max} step={1}
                                    value={sliderVal}
                                    disabled={isOrderFinished}
                                    onChange={e => onSliderChange(f.key, e.target.value)}
                                />
                            </div>
                            <div className="meas-minmax">
                                <span>{f.min} mm</span>
                                <span>{f.max} mm</span>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="cfg-confirm-footer">
                <button
                    className="cfg-confirm-btn"
                    onClick={onBack}
                    style={{ background: '#F5F0EA', color: '#6B5A4A', borderRight: '1px solid #EAE4DA' }}
                >
                    Back
                </button>
                <button
                    className="cfg-confirm-btn"
                    onClick={onConfirm}
                    disabled={isOrderFinished || hasAnyError}
                    style={{ background: !isOrderFinished && !hasAnyError ? '#1A110B' : '#D0C8BF', color: '#FFFFFF' }}
                >
                    Confirm
                </button>
            </div>
        </>
    );
};

export default MeasurementPanel;
